import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Card, CardContent } from "@mui/material";
import LatestNewsImage from "../../../../../Assets/latestNewsImage.jpg";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../../../ReduxStore/actions";
import { adminUrl } from "../../../../../constants";
import ModalApproveButton from "../../../../../Components/ModalButton/HomeSectionButton/ModalApproveButton";

const LatestNewsSection = ({
  latestDates,
  handleReadMoreOpenModal,
  setReadMoreModalContent,
  values,
  onClose,
  sectionNameForApproveAndReject
}) => {


  const [responseData, setResponseData] = useState()

  console.log(values, "valuesssss")
  console.log(responseData, "responseDatattaatatatt")
  const TableId = useSelector((state) => state.Table.TableId);

  console.log(TableId, "TebleIddddd")

  const dispatch = useDispatch()

  useEffect(() => {
    console.log(TableId, "TebleIddddd111")

    if (TableId && !values) {
      console.log(TableId, "TebleIddddd222")

      const fetchData = async () => {
        const data1 = {
          data: {},
          method: "get",
          apiName: `getBlogSectionById/${TableId}`,
        };
        const response = await dispatch(actions.GETBLOGSECTIONBYID(data1));

        console.log(response, "responseresponse")

        if (response?.payload?.message === "Blog section retrieved successfully.") {
          console.log("hiiii")

          setResponseData(response?.payload?.data)
          // setUploadedFile({
          //     fileUrl: response?.payload?.data.additional_data[0]?.banner,
          //     type: "img",
          //     progress: 100,
          // }
          // )
          // console.log(response?.payload?.data.additional_data[0]?.banner,"yhfuwrfrkjrw")
        }
      };
      fetchData();
    }

  }, []);


  const [modalData, setModalData] = useState();
  useEffect(() => {
    setModalData({
      title: latestDates?.[0]?.additional_data?.card_design?.title,
      secondary_title:
        latestDates?.[0]?.additional_data?.card_design?.secondary_title,
      image: latestDates?.[0]?.additional_data?.card_design?.banner,
      textContent: latestDates?.[0]?.additional_data?.card_design?.content,
    });
  }, []);

  return (
    <Box>
      <Box
        sx={{
          // padding: 4,
          // backgroundColor: "#f9f9f9",
          backgroundColor: "white",

          minHeight: "70vh"
        }}
      >
        {/* Header Section */}
        <Box sx={{ textAlign: "center", marginBottom: 4 }}>
          <Typography
            variant="h3"
            sx={{
              marginBottom: 1,
            }}
          >
            {responseData?.heading || values?.heading_title || "Latest News &"}
            <span style={{ color: "black", fontWeight: "700" }}>
              &nbsp;{responseData?.sub_heading || values?.heading_second_text || "Blogs"}
            </span>
          </Typography>
          <Typography
            variant="body1"
            sx={{
              maxWidth: "800px",
              margin: "0 auto",
              color: "#555",

              lineHeight: 1.6,
            }}
          >
            {responseData?.content || values?.heading_sub_text ||
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."}
          </Typography>
        </Box>

        {/* Image and Card Section */}
        <Box
          sx={{
            position: "relative",
            maxWidth: "100%",
            margin: "0 auto",
            pb: 6,
          }}
        >
          {/* Image */}
          <Box
            component="img"
            src={`${adminUrl}${responseData?.additional_data?.card_design[0]?.logo || values?.cards[0]?.image?.fileUrl}`}
            // src={LatestNewsImage}
            alt="Blog Preview"
            sx={{
              width: "50%", // Ensure the image takes full width of its container
              width: { xs: "100%", sm: "60%", md: "50%" }, // Restrict max width

              maxWidth: { xs: "100%", sm: "70%", md: "100%" }, // Restrict max width
              // height: "90%", // Maintain aspect ratio
              minHeight: { xs: "200px", sm: "300px", md: "300px" }, // Custom max height for the image
              borderRadius: "12px",
              objectFit: "cover", // Prevent stretching or distortion
            }}
          />

          {/* Card */}
          <Card
            sx={{
              position: "absolute",
              top: { xs: "10%", sm: "30%", md: "20%" },
              left: { xs: "9%", sm: "30%", md: "40%" },
              width: { xs: "80%", sm: "65%", md: "55%" },
              borderRadius: 2,
              boxShadow: "0px 8px 20px rgba(0,0,0,0.15)",
              backgroundColor: "#fff",
              zIndex: 10,
              // px: 1,
            }}
          >
            <CardContent>
              <Typography
                variant="body1"
                sx={{ color: "#C38F51", marginBottom: 0.5 }}
              >
                {responseData?.additional_data?.card_design[0]?.title || values?.cards[0]?.card_title || "Stay Connected"}
                {/* Stay Connected */}
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  // fontWeight: "bold",
                  marginBottom: 1,
                  color: "#333",
                  // fontSize: { xs: 18, md: 24 },
                }}
              >
                {/* {latestDates?.[0]?.additional_data?.card_design?.secondary_title} */}
                {responseData?.additional_data?.card_design[0]?.cart_title_secondtext || values?.cards[0]?.cart_title_secondtext || "Discover the Golden Opportunity"}


              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "#666",
                  // textAlign: "justify",
                  marginBottom: 2,
                  // fontSize: { xs: 12, md: 14 },
                  lineHeight: 1.6,
                  height: { xs: "100px", md: "160px" }, // Set maximum text height
                  overflow: "hidden", // Hide overflow text
                }}
              >
                {/* {latestDates?.[0]?.additional_data?.card_design?.content} */}
                {responseData?.additional_data?.card_design[0]?.content || values?.cards[0]?.card_content || "Default content"}

              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <Button
                  // onClick={() => {
                  //   handleReadMoreOpenModal(modalData);
                  // }}
                  variant="contained"
                  color="warning"
                  sx={{
                    textTransform: "none",
                    // fontWeight: "bold",
                    background: "#C38F51",
                    borderRadius: 20,
                    px: 3,
                    // fontSize: { xs: 12, md: 14 },
                  }}
                >
                  {/* {
                  latestDates?.[0]?.additional_data?.card_design
                    ?.primary_button_text
                } */}
                  {responseData?.additional_data?.card_design[0]?.card_primary_button_text || values?.cards[0]?.card_primary_button_text || "Default content"}

                  {/* Let's Explore... */}
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Box>
      <ModalApproveButton approveStatus={responseData?.approval_status} values={values} onClose={onClose} sectionNameForApproveAndReject={sectionNameForApproveAndReject} />
    </Box >
  );
};

export default LatestNewsSection;
